Promise.all([import('@meteora-digital/modal'), import('scripts/marmalade/classes/video-embed')]).then(_ref => {
  let [moduleModal, moduleVideoEmbed] = _ref;
  // Define the components
  const ModalController = moduleModal.default;
  const VideoController = moduleVideoEmbed.default;
  DomObserver.observe('[data-video-modal]', blocks => {
    blocks.forEach(block => {
      // Get the video url
      const url = block.getAttribute('data-video-modal');
      // Create a new modal
      const Modal = new ModalController();
      // Create a new VideoEmbed
      const Video = new VideoController(url);
      // A div to hold the video
      const container = document.createElement('div');
      const holder = document.createElement('div');
      container.classList.add('responsive-video');
      holder.classList.add('responsive-video__holder');
      container.appendChild(holder);
      holder.appendChild(Video.iframe);
      Modal.append(container);

      // When we click on the block, append the Video.iframe to the block
      block.addEventListener('click', e => {
        e.preventDefault();
        Modal.open();
      });
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});